var bnurl = "https://djbanner.oss-cn-shenzhen.aliyuncs.com/"; //轮播图
var FirstlvSort_image = "https://shopsbig.oss-cn-shenzhen.aliyuncs.com/"; //1级分类
var FirstlvSort_banner =
  "https://shopsbig-banner.oss-cn-shenzhen.aliyuncs.com/"; //1级分类横幅
var ThreelvSort_image = "https://shopssamll.oss-cn-shenzhen.aliyuncs.com/"; //三级分类图片

var Goods_banner = "https://master-graph.oss-cn-shenzhen.aliyuncs.com/"; //商品轮播图/列表图
var Goodsdetail_banner =
  "https://details-picture.oss-cn-shenzhen.aliyuncs.com/"; //商品详情
var brand = "	https://shopsbrand.oss-cn-shenzhen.aliyuncs.com/"; //品牌
var moduleUrl = "https://plate-photo.oss-cn-shenzhen.aliyuncs.com/"; //模块图片，（模块分类和首页都一样)
var moduleUrl2 = "https://shopsbig-list-img.oss-cn-shenzhen.aliyuncs.com/"; //模块分类商品大图
var brandImage = 'https://gift-banner.oss-cn-shenzhen.aliyuncs.com/' //大牌
export default {
  bnurl,
  FirstlvSort_image,
  FirstlvSort_banner,
  ThreelvSort_image,
  Goods_banner,
  Goodsdetail_banner,
  brand,
  moduleUrl,
  moduleUrl2,
  brandImage
};



// WEBPACK FOOTER //
// ./src/units/baseUrl.js